import axios from 'axios';

import { axiosInstance } from 'apis';
import { getBaseURL } from 'utility/baseURL';

const generalToken = `Bearer 85370210-F4D9-46AB-88C2-83C4F3F43704`;
const etmaBaseURL = 'https://api.kipaa.ir/keepaapp/v2';

const baseURL = getBaseURL();

const ELanding = {
	sms: baseURL + '/keepaSite/landingLeads',
	registration: `${etmaBaseURL}/Services/EtmaRegistration`,
	confirm: `${etmaBaseURL}/Services/EtmaRegistrationConfirm`,
	resend: `${etmaBaseURL}/Services/EtmaRegistrationReSendSMS`,
};

const landingAPIs = {
	sendSMS: (data, option = {}) => axiosInstance.post(ELanding.sms, data, option),
	etmaRegistration: (data) =>
		axios.post(ELanding.registration, data, {
			headers: {
				Authorization: generalToken,
			},
		}),
	etmaRegistrationConfirm: (data) =>
		axios.post(ELanding.confirm, data, {
			headers: {
				Authorization: generalToken,
			},
		}),
	etmaRegistrationReSendSMS: (data) =>
		axios.post(ELanding.resend, data, {
			headers: {
				Authorization: generalToken,
			},
		}),
};

export { ELanding, landingAPIs };
